import React from "react";
import { Link } from "react-router-dom";
import { Users, Fuel, Settings2, ArrowRight } from "lucide-react";
import { useT } from "../i18n";

const fuelKey = (f) => ({ petrol: "fleet.petrol", diesel: "fleet.diesel", electric: "fleet.electric", hybrid: "fleet.hybrid" }[f] || f);

export const CarCard = ({ car, index = 0 }) => {
  const { t } = useT();
  return (
    <Link to={`/cars/${car.car_id}`} data-testid={`car-card-${car.car_id}`}
      className="group border border-border bg-card hover:shadow-xl hover:-translate-y-1 transition-all duration-200 flex flex-col animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}>
      <div className="aspect-[16/10] overflow-hidden bg-secondary">
        <img src={car.images?.[0]} alt={car.name} loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-2">
          <div>
            <p className="text-xs uppercase tracking-wider text-muted-foreground">{car.brand}</p>
            <h3 className="font-heading font-semibold text-lg leading-tight">{car.name}</h3>
          </div>
          <span className="text-xs font-semibold px-2 py-1 bg-secondary rounded-md uppercase">{car.category}</span>
        </div>

        <div className="flex items-center gap-4 mt-4 text-sm text-muted-foreground">
          <span className="flex items-center gap-1"><Users className="h-4 w-4" /> {car.seats}</span>
          <span className="flex items-center gap-1"><Settings2 className="h-4 w-4" /> {t(car.transmission === "automatic" ? "fleet.automatic" : "fleet.manual")}</span>
          <span className="flex items-center gap-1"><Fuel className="h-4 w-4" /> {t(fuelKey(car.fuel))}</span>
        </div>

        <div className="flex items-end justify-between mt-5 pt-4 border-t border-border">
          <div>
            <span className="font-heading text-2xl font-bold">{car.price_per_day}</span>
            <span className="text-sm text-muted-foreground"> {t("common.currency")}{t("car.per_day")}</span>
          </div>
          <span className="flex items-center gap-1 text-sm font-semibold text-accent group-hover:gap-2 transition-all">
            {t("car.request_title")} <ArrowRight className="h-4 w-4" />
          </span>
        </div>
      </div>
    </Link>
  );
};
